<template lang="html">
  <div class="">
    <vs-button @click="isActive=true" color="success" type="filled" icon-pack="feather" icon="icon-plus" class="w-full">
      {{ $t('account') }}
    </vs-button>
    <vs-popup :title="$t('add_new_bank_account')" :active.sync="isActive" ef="loadableButton" id="add-bank-account-loading" class="vs-con-loading__container">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4">
          <label>{{$t('client')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="8" vs-lg="8">
          <v-select class="w-full select-custom" :options="clients" label="ClientName" :reduce="client => client.ClientId" name="client" v-validate="'required'" v-model="form.client" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('client')">
           {{ errors.first('client') }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4">
          <label>{{$t('bank')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="8" vs-lg="8">
          <v-select class="w-full select-custom" :options="banks" label="short_name" :reduce="bank => bank.id" v-validate="'required'" name="bank" v-model="form.bank" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('bank')">
           {{ errors.first('bank') }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4">
          <label>{{$t('account_number')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="8" vs-lg="8">
          <vs-input class="w-full" v-validate="'required'" v-model="form.account" name="account" autocomplete="off" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('account')">
           {{ errors.first('account') }}
          </span>
        </vs-col>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4">
          <label>{{$t('currency')}}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="8" vs-lg="8">
           <v-select class="w-full select-custom" :options="currencies" label="text" :reduce="currency => currency.id" v-validate="'required'" name="currency" v-model="form.currency" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
          <span class="text-danger text-sm" v-show="errors.has('currency')">
           {{ errors.first('currency') }}
          </span>
        </vs-col>
      </vs-row>

      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-xs="12"
          vs-sm="8"
          vs-lg="8"
        >
          <vs-checkbox v-model="form.cash_request_account">{{
            $t('cash_request_account')
          }}</vs-checkbox>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-justify="flex-end" class="mb-2">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="4" vs-lg="4" class="p-2">
          <vs-button class="w-full" color="danger" type="border" @click="handleClose" :disabled="submited">
            {{ $t('cancel') }}
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-xs="12" vs-sm="3" vs-lg="3" class="p-2">
          <vs-button class="w-full" color="danger" type="filled" @click="handleSubmit" :disabled="disabledSubmit">
            {{ $t('submit') }}
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import statement from '@/http/requests/statement'
import loading from '@/mixins/Loading.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect
  },
  computed: {
    disabledSubmit(){
      return this.form.client === '' || this.form.bank === '' || this.form.account === ''|| this.form.currency === '' || this.submited
    },
    isLoading() {
      return this.loading.period || this.loading.bank || this.loading.submit
    }
  },
  data: () => ({
    submited:false,
    isActive: false,
    defaultForm: {
      client: '',
      bank: '',
      account: '',
      currency: '',
      cash_request_account:false
    },
    form: {
      client: '',
      bank: '',
      account: '',
      currency: '',
      cash_request_account:false
    },
    currencies:[{ id:'USD',text:'USD'},{ id:'MXN',text:'MXN'}],
    loading: {
      submit: false,
    }
  }),
  methods: {
    handleClose() {
      this.isActive = false
    },
    handleSubmit() {
      this.submited=true
      statement.storeAccount(this.form).then(res => {
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'Item Added'
          })
          this.handleClose()
          this.$emit('success')
          this.submited=false
        }).catch(err => {
          console.log(err)
          this.submited=false
        })
    },
    init() {
      this.$validator.reset()
      this.form = Object.assign({}, this.defaultForm)
    }
  },
  mixins: [loading],
  props: {
    banks: {
      type: Array,
      default: () => []
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    isActive(val) {
      if (val) {
        this.init()
      }
    },
    isLoading(val) {
      if (val) {
        this.openLoading('add-bank-account-loading')
        return
      }
      this.closeLoading('add-bank-account-loading')
      return
    }
  }
}

</script>
<style>
.select-custom >.vs__dropdown-menu {
  max-height: 80px;
}

</style>
